import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import {
  Card,
  Grid,
  TextField,
  IconButton,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import { Navigate } from "react-router-dom";

export default class AddProduct extends Component {
  state = {
    product_name: "",

    product_images: [],
    product_details: [{ key: "", value: "" }],
    key_features: [""],
    applications: [""],

    datasheet: null,
    technical_drawing: null,
    installation_manual: null,

    loading: false,
    notification: false,
    message: "",
    redirect: false,
    description: ""
  };

  /* =========================
     HANDLERS
  ========================= */
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleArrayChange = (type, index, value) => {
    const arr = [...this.state[type]];
    arr[index] = value;
    this.setState({ [type]: arr });
  };

  handleKeyValueChange = (index, field, value) => {
    const data = [...this.state.product_details];
    data[index][field] = value;
    this.setState({ product_details: data });
  };

  addItem = (type, empty) => {
    this.setState({ [type]: [...this.state[type], empty] });
  };

  removeItem = (type, index) => {
    const arr = [...this.state[type]];
    arr.splice(index, 1);
    this.setState({ [type]: arr });
  };

  handleDescription = (content) => {
    this.setState({ description: content });
  };

  /* =========================
     SUBMIT
  ========================= */
  handleSubmit = async (e) => {
    e.preventDefault();
    if (init() !== "success") return this.setState({ redirect: true });

    this.setState({ loading: true });

    const formData = new FormData();

    formData.append("product_name", this.state.product_name);

    this.state.product_images.forEach((img) =>
      formData.append("product_images", img)
    );

    formData.append(
      "product_details",
      JSON.stringify(this.state.product_details.filter(i => i.key && i.value))
    );

    formData.append(
      "key_features",
      JSON.stringify(this.state.key_features.filter(Boolean))
    );

    formData.append(
      "applications",
      JSON.stringify(this.state.applications.filter(Boolean))
    );

    formData.append("description", this.state.description)

    if (this.state.datasheet)
      formData.append("datasheet", this.state.datasheet);

    if (this.state.technical_drawing)
      formData.append("technical_drawing", this.state.technical_drawing);

    if (this.state.installation_manual)
      formData.append("installation_manual", this.state.installation_manual);

    try {
      await axios.post(Constants.postUrls.createProduct, formData);

      this.setState({
        notification: true,
        message: "Product added successfully",
        loading: false,
      });

      setTimeout(() => this.setState({ redirect: true }), 2000);
    } catch (err) {
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong",
        loading: false,
      });
    }
  };

  /* =========================
     RENDER
  ========================= */
  render() {
    if (this.state.redirect) return <Navigate to="/products" replace />;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info">
              <MDTypography color="white">Add Product</MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>

                  {/* PRODUCT NAME */}
                  <Grid item xs={12}>
                    <TextField
                      fullWidth
                      required
                      label="Product Name"
                      name="product_name"
                      onChange={this.handleChange}
                    />
                  </Grid>

                  {/* PRODUCT IMAGES */}
                  <Grid item xs={12}>
                    <TextField
                      type="file"
                      label="Product Images"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ multiple: true }}
                      onChange={(e) =>
                        this.setState({
                          product_images: Array.from(e.target.files),
                        })
                      }
                    />
                  </Grid>

                  {/* PRODUCT DETAILS */}
                  <Grid item xs={12}>
                    <MDTypography>Product Details</MDTypography>
                    {this.state.product_details.map((item, i) => (
                      <Grid container spacing={1} key={`detail-${i}`} style={{marginTop: "10px"}}>
                        <Grid item xs={5}>
                          <TextField
                            fullWidth
                            label="Key"
                            value={item.key}
                            onChange={(e) =>
                              this.handleKeyValueChange(i, "key", e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Value"
                            value={item.value}
                            onChange={(e) =>
                              this.handleKeyValueChange(i, "value", e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <IconButton onClick={() => this.removeItem("product_details", i)}>
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    ))}
                    <MDButton
                      size="small"
                      onClick={() => this.addItem("product_details", { key: "", value: "" })}
                    >
                      <AddIcon /> Add Detail
                    </MDButton>
                  </Grid>

                  {/* KEY FEATURES */}
                  <Grid item xs={12}>
                    <MDTypography>Key Features</MDTypography>
                    {this.state.key_features.map((item, i) => (
                      <Grid container spacing={1} key={`feature-${i}`} style={{marginTop: "10px"}}>
                        <Grid item xs={11}>
                          <TextField
                            fullWidth
                            value={item}
                            onChange={(e) =>
                              this.handleArrayChange("key_features", i, e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <IconButton onClick={() => this.removeItem("key_features", i)}>
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    ))}
                    <MDButton size="small" onClick={() => this.addItem("key_features", "")}>
                      <AddIcon /> Add Feature
                    </MDButton>
                  </Grid>

                  {/* APPLICATIONS */}
                  <Grid item xs={12}>
                    <MDTypography>Applications</MDTypography>
                    {this.state.applications.map((item, i) => (
                      <Grid container spacing={1} key={`app-${i}`} style={{marginTop: "10px"}}>
                        <Grid item xs={11}>
                          <TextField
                            fullWidth
                            value={item}
                            onChange={(e) =>
                              this.handleArrayChange("applications", i, e.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <IconButton onClick={() => this.removeItem("applications", i)}>
                            <DeleteIcon />
                          </IconButton>
                        </Grid>
                      </Grid>
                    ))}
                    <MDButton size="small" onClick={() => this.addItem("applications", "")}>
                      <AddIcon /> Add Application
                    </MDButton>
                  </Grid>

                  {/* DOWNLOAD FILES */}
                  <Grid item xs={12} sm={4}>
                    <TextField
                      type="file"
                      label="Datasheet"
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => this.setState({ datasheet: e.target.files[0] })}
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      type="file"
                      label="Technical Drawing"
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) =>
                        this.setState({ technical_drawing: e.target.files[0] })
                      }
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    <TextField
                      type="file"
                      label="Installation Manual"
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) =>
                        this.setState({ installation_manual: e.target.files[0] })
                      }
                    />
                  </Grid>

  <Grid item xs={12}>
                    <SunEditor
                      setDefaultStyle="font-family: Arial; font-size: 16px;"
                      setOptions={{
                        height: 200,
                        buttonList: [
                          ["bold", "italic", "underline"],
                          ["fontColor", "hiliteColor"],
                          ["align", "list"],
                          ["link"],
                          ["removeFormat"],
                        ],
                      }}
                      setContents={this.state.description}
                      onChange={this.handleDescription}
                    />
                  </Grid>
                </Grid>

                <MDBox mt={3}>
                  <MDButton type="submit" color="info" disabled={this.state.loading}>
                    {this.state.loading ? "Saving..." : "Create Product"}
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>

            <MDSnackbar
              open={this.state.notification}
              content={this.state.message}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
